var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment, useState, useEffect, useMemo, useRef } from 'react';
import { fabric } from 'fabric';
import { I18n, findScaleToContain, loadFont } from '@mademine/utils';
import { useData } from '../../hooks/useData';
import { getKeyPoint, getZIndex, loadImageFromURL, loadSVGFromURL, thumbnailOss } from '../../utils';
import DefaultFace from './DefaultFace';
import { cloneDeep } from 'lodash';
import classNames from 'classnames';
var ChoosePreviewOption = function (_a) {
    var bodyUrl = _a.bodyUrl, option = _a.option, bottomImageWidth = _a.bottomImageWidth, bottomImageHeight = _a.bottomImageHeight, avatars = _a.avatars, avatarWidth = _a.avatarWidth, avatarHeight = _a.avatarHeight, avatarLeft = _a.avatarLeft, avatarTop = _a.avatarTop, avatarScale = _a.avatarScale, avatarAngle = _a.avatarAngle, forceUpdate = _a.forceUpdate;
    var _b = useData(), peopleNumber = _b.peopleNumber, _c = _b.shop, theme = _c.theme, language = _c.language, selectedColor = _b.selectedColor, backSideNewImage = _b.backSideNewImage, setBackSideNewImage = _b.setBackSideNewImage, productType = _b.productType;
    var preAvatars = useRef([]);
    var _d = useState(''), previewTexture = _d[0], setPreviewTexture = _d[1];
    var isPathImage = useMemo(function () {
        var pathArr = option.origin.avatar
            .map(function (item, index) { return ({
            path: item.path || '',
            index: index
        }); })
            .filter(function (item) { return item.path; });
        var lineText = option.origin.text || [];
        return pathArr.length !== 0 || lineText.length !== 0;
    }, [option.origin]);
    var avatarImages = useMemo(function () {
        if (preAvatars.current.length === 0) {
            preAvatars.current = avatars.map(function (item) { return item.image; });
        }
        else {
            var next_1 = avatars.map(function (item) { return item.image; });
            var isEqua = preAvatars.current.every(function (item, index) { return item === next_1[index]; });
            if (!isEqua)
                preAvatars.current = next_1;
        }
        return preAvatars.current;
    }, [avatars]);
    var _e = useState(isPathImage), pathImage = _e[0], setPathImage = _e[1];
    var handleLoaded = function (image) {
        if (image) {
            option.loading[image] = false;
        }
        else {
            for (var i in option.loading) {
                option.loading[i] = false;
            }
        }
        forceUpdate();
    };
    var createPathImage = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _avatarObject;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, Promise.all(avatars.map(function (item) { return __awaiter(void 0, void 0, void 0, function () {
                        var object;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!item.isDefault) return [3, 2];
                                    return [4, loadSVGFromURL(item.image || '')];
                                case 1:
                                    object = (_a.sent());
                                    object.forEachObject(function (element) {
                                        element.set({
                                            fill: "rgba(".concat(theme.r, ", ").concat(theme.g, ", ").concat(theme.b, ", ").concat(element.fillOpacity || 1, ")")
                                        });
                                    });
                                    return [2, object];
                                case 2: return [2, loadImageFromURL(item.image || '')];
                            }
                        });
                    }); }))];
                case 1:
                    _avatarObject = _a.sent();
                    createAvatarPath(option.origin, _avatarObject);
                    return [2];
            }
        });
    }); };
    var handleFabricTextScale = function (text, width, height) {
        var textContext = text.getMeasuringContext();
        textContext.font = "".concat(text.fontSize, "px ").concat(text.fontFamily);
        textContext.textBaseline = 'top';
        var actualWidth = 0;
        for (var i = 0; i < text.textLines.length; i += 1) {
            var _a = textContext.measureText(text.textLines[i] || ''), alignToLeft = _a.actualBoundingBoxLeft, alignToRight = _a.actualBoundingBoxRight;
            alignToLeft = Math.ceil(alignToLeft);
            alignToRight = Math.ceil(alignToRight);
            if (actualWidth < alignToRight + alignToLeft) {
                actualWidth = alignToRight + alignToLeft;
            }
        }
        var canvasWidth = width;
        var canvasHeight = height;
        var textHeight = text.height || 0;
        var textWidth = text.width || 0;
        var diffHeight = canvasHeight * 0.1;
        var diffWidth = canvasWidth * 0.1;
        if (actualWidth > canvasWidth - diffWidth ||
            textHeight > canvasHeight - diffHeight) {
            var currentHeight = textHeight + diffHeight;
            var multiScale = findScaleToContain({ width: textWidth, height: currentHeight }, {
                width: canvasWidth,
                height: canvasHeight
            });
            if (multiScale <= 1)
                text.scale(multiScale);
        }
        else {
            text.scale(1);
        }
    };
    var renderText = function (data, canvas) { return __awaiter(void 0, void 0, void 0, function () {
        var text, canvasWidth_1, canvasHeight_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    text = data.text;
                    if (!text) return [3, 2];
                    canvasWidth_1 = canvas.getWidth();
                    canvasHeight_1 = canvas.getHeight();
                    return [4, Promise.all(text.map(function (textItem) { return __awaiter(void 0, void 0, void 0, function () {
                            var textWidthScale, textHeightScale, scale, textLeft, textTop, textValue, fabricText;
                            var _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        textWidthScale = canvasWidth_1 / data.width;
                                        textHeightScale = canvasHeight_1 / data.height;
                                        scale = Math.min(textWidthScale, textHeightScale);
                                        textLeft = textItem.left * scale + (scale * textItem.width) / 2;
                                        textTop = textItem.top * scale + (scale * textItem.height) / 2;
                                        return [4, loadFont(textItem.font)];
                                    case 1:
                                        _b.sent();
                                        textValue = textItem.text ||
                                            (typeof textItem.defaultText === 'string'
                                                ? textItem.defaultText
                                                : (_a = textItem.defaultText) === null || _a === void 0 ? void 0 : _a[language]) ||
                                            I18n.format('text.default.text') ||
                                            '';
                                        fabricText = new fabric.Textbox(textValue, {
                                            fontFamily: textItem.font.name,
                                            fontSize: textItem.fontSize * scale,
                                            lineHeight: textItem.lineHeight
                                                ? (textItem.lineHeight * scale) / (textItem.fontSize * scale)
                                                : 1.16,
                                            left: textLeft,
                                            top: textTop,
                                            originX: 'center',
                                            originY: 'center',
                                            fill: textItem.color,
                                            charSpacing: textItem.charSpacing || 0,
                                            width: textItem.width * scale,
                                            height: textItem.height * scale,
                                            textAlign: 'center'
                                        });
                                        handleFabricTextScale(fabricText, textItem.width * scale, textItem.height * scale);
                                        canvas.add(fabricText);
                                        return [2];
                                }
                            });
                        }); }))];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2];
            }
        });
    }); };
    var createAvatarPath = function (data, avatar) { return __awaiter(void 0, void 0, void 0, function () {
        var pathArr, element, canvas, imageURL, bodyURL, body, canvasWidth, canvasHeight, imageStrokeURL, bodyStrokeURL, bodyStroke, pathArrResult, pathArrPromise, annexsURL, annexs, originalCanvas, canvasCopy, ctx;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    pathArr = option.origin.avatar
                        .map(function (item, index) { return ({
                        path: item.path || '',
                        index: index
                    }); })
                        .filter(function (item) { return item.path; });
                    element = document.createElement('canvas');
                    canvas = new fabric.Canvas(element);
                    imageURL = data.images.find(function (item) {
                        return item.color.includes(selectedColor.map(function (item) { return item.name; }).join('-'));
                    }).url;
                    bodyURL = thumbnailOss(imageURL, 300);
                    return [4, loadImageFromURL(bodyURL)];
                case 1:
                    body = _e.sent();
                    canvas.setDimensions({
                        width: 300,
                        height: (data.height / data.width) * 300
                    });
                    canvasWidth = canvas.getWidth();
                    canvasHeight = canvas.getHeight();
                    body
                        .set({
                        left: canvas.getWidth() / 2,
                        top: canvas.getHeight(),
                        originY: 'bottom',
                        originX: 'center'
                    })
                        .scale(Math.min(canvasWidth / ((_a = body.width) !== null && _a !== void 0 ? _a : 0), canvasHeight / ((_b = body.height) !== null && _b !== void 0 ? _b : 0)));
                    canvas.add(body);
                    if (!(productType === 'balloon' && data.strokeImages)) return [3, 3];
                    imageStrokeURL = data.strokeImages;
                    bodyStrokeURL = thumbnailOss(imageStrokeURL, 300);
                    return [4, loadImageFromURL(bodyStrokeURL)];
                case 2:
                    bodyStroke = _e.sent();
                    bodyStroke
                        .set({
                        left: canvas.getWidth() / 2,
                        top: canvas.getHeight(),
                        originY: 'bottom',
                        originX: 'center'
                    })
                        .scale(Math.min(canvasWidth / ((_c = bodyStroke.width) !== null && _c !== void 0 ? _c : 0), canvasHeight / ((_d = bodyStroke.height) !== null && _d !== void 0 ? _d : 0)));
                    canvas.add(bodyStroke);
                    _e.label = 3;
                case 3:
                    generateBackSideNewImage(canvas);
                    pathArrResult = [];
                    if (!(pathArr.length > 0)) return [3, 5];
                    pathArrPromise = pathArr.map(function (item) { return __awaiter(void 0, void 0, void 0, function () {
                        var object;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4, loadSVGFromURL(item.path)];
                                case 1:
                                    object = _a.sent();
                                    return [2, { object: object, index: item.index }];
                            }
                        });
                    }); });
                    return [4, Promise.all(pathArrPromise)];
                case 4:
                    pathArrResult = _e.sent();
                    pathArrResult.forEach(function (_a) {
                        var _b, _c;
                        var path = _a.object;
                        var pathLeft = (((_b = path.left) !== null && _b !== void 0 ? _b : 0) / data.width) * canvasWidth;
                        var pathTop = (((_c = path.top) !== null && _c !== void 0 ? _c : 0) / data.height) * canvasHeight;
                        path
                            .set({
                            fill: 'transparent',
                            absolutePositioned: true,
                            left: pathLeft,
                            top: pathTop
                        })
                            .scale(Math.min(canvasWidth / data.width, canvasHeight / data.height));
                    });
                    _e.label = 5;
                case 5: return [4, Promise.all(option.origin.avatar.map(function (avatarItem, index) { return __awaiter(void 0, void 0, void 0, function () {
                        var avatarWidth, avatarHeight, avatarLeft, avatarTop, scale, userImage, faceRect, face, faceItem, faceWidth, faceHeight, heightDistance, avatarWidth_1, avatarClip;
                        var _a, _b;
                        return __generator(this, function (_c) {
                            avatarWidth = (avatarItem.width / data.width) * canvasWidth;
                            avatarHeight = (avatarItem.height / data.height) * canvasHeight;
                            avatarLeft = ((avatarItem.left + avatarItem.width / 2) / data.width) * canvasWidth;
                            avatarTop = ((avatarItem.top + avatarItem.height) / data.height) * canvasHeight;
                            scale = Math.min(avatarWidth / ((_a = avatar[index].width) !== null && _a !== void 0 ? _a : 0), avatarHeight / ((_b = avatar[index].height) !== null && _b !== void 0 ? _b : 0));
                            userImage = avatars[index];
                            if (!userImage.isDefault && userImage.faceRecognizeData && data.face) {
                                faceRect = userImage.faceRecognizeData.faceRect;
                                face = data.face;
                                faceItem = face[index];
                                faceWidth = (faceItem.width / data.width) * canvasWidth;
                                faceHeight = (faceItem.height / data.height) * canvasHeight;
                                scale = Math.min(faceWidth / faceRect.width, faceHeight / faceRect.height);
                                heightDistance = (avatar[index].height -
                                    faceRect.top -
                                    faceRect.height) *
                                    scale;
                                avatarTop =
                                    ((faceItem.top + faceItem.height) / data.height) * canvasHeight +
                                        heightDistance;
                                avatarWidth_1 = avatar[index].width * scale;
                                avatarLeft =
                                    (faceItem.left / data.width) * canvasWidth -
                                        faceRect.left * scale +
                                        avatarWidth_1 / 2;
                            }
                            else {
                            }
                            avatarClip = pathArrResult.find(function (item) { return index === item.index; });
                            avatar[index]
                                .set({
                                left: avatarLeft,
                                top: avatarTop,
                                originY: 'bottom',
                                originX: 'center',
                                clipPath: avatarClip === null || avatarClip === void 0 ? void 0 : avatarClip.object
                            })
                                .scale(scale);
                            canvas.add(avatar[index]);
                            return [2];
                        });
                    }); }))];
                case 6:
                    _e.sent();
                    if (!(Array.isArray(data.annex) && data.annex.length > 0)) return [3, 8];
                    annexsURL = data.annex.map(function (item) {
                        var url = item.images.find(function (image) {
                            return image.color.includes(selectedColor.map(function (item) { return item.name; }).join('-'));
                        }).url;
                        return {
                            url: thumbnailOss(url, 200),
                            blongIndex: item.belongIndex
                        };
                    });
                    return [4, Promise.all(annexsURL.map(function (item) { return __awaiter(void 0, void 0, void 0, function () {
                            var image;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4, loadImageFromURL(item.url)];
                                    case 1:
                                        image = _a.sent();
                                        return [2, { image: image, belongIndex: item.blongIndex }];
                                }
                            });
                        }); }))];
                case 7:
                    annexs = _e.sent();
                    annexs.forEach(function (_a, index) {
                        var _b, _c;
                        var item = _a.image, belongIndex = _a.belongIndex;
                        var currentAnnex = data.annex[index];
                        var userImage = avatars[belongIndex || 0];
                        if (userImage.faceRecognizeData && productType !== 'balloon') {
                            var faceRect = userImage.faceRecognizeData.faceRect;
                            var face = data.face;
                            var faceItem = face[belongIndex || 0];
                            var _d = currentAnnex.faceFit, leftPoint = _d.leftPoint, rightPoint = _d.rightPoint, feature = _d.feature;
                            var avatarImageScale = avatar[belongIndex || 0].scaleX;
                            var avatarFaceWidth = faceRect.width * avatarImageScale;
                            var faceFitWidth = (faceItem.width / data.width) * canvasWidth;
                            var faceFitLeft = (faceItem.left / data.width) * canvasWidth;
                            var scale = item.width / currentAnnex.width;
                            var keyPoint = getKeyPoint(userImage, feature);
                            var annexTop = void 0;
                            var annexScale = avatarFaceWidth / ((rightPoint.left - leftPoint.left) * scale);
                            if (feature === 'head') {
                                annexTop =
                                    avatar[belongIndex || 0]._getLeftTopCoords().y +
                                        keyPoint.y * avatarImageScale -
                                        100 * avatarImageScale -
                                        leftPoint.top * scale * annexScale;
                            }
                            else {
                                annexTop =
                                    avatar[belongIndex || 0]._getLeftTopCoords().y +
                                        keyPoint.y * avatarImageScale -
                                        leftPoint.top * scale * annexScale;
                            }
                            var faceLeft = faceFitLeft + (faceFitWidth - avatarFaceWidth) / 2;
                            var annexLeft = faceLeft - leftPoint.left * scale * annexScale;
                            item
                                .set({
                                left: annexLeft,
                                top: annexTop
                            })
                                .scale(annexScale);
                        }
                        else {
                            var annexLeft = ((currentAnnex.left + currentAnnex.width / 2) / data.width) *
                                canvasWidth;
                            var annexTop = ((currentAnnex.top + currentAnnex.height / 2) / data.height) *
                                canvasHeight;
                            var annexWidth = (currentAnnex.width / data.width) * canvasWidth;
                            var annexHeight = (currentAnnex.height / data.height) * canvasHeight;
                            var annexScale = Math.min(annexWidth / ((_b = item.width) !== null && _b !== void 0 ? _b : 0), annexHeight / ((_c = item.height) !== null && _c !== void 0 ? _c : 0));
                            item
                                .set({
                                originY: 'center',
                                originX: 'center',
                                left: annexLeft,
                                top: annexTop
                            })
                                .scale(annexScale);
                        }
                        canvas.add(item);
                    });
                    _e.label = 8;
                case 8: return [4, renderText(data, canvas)];
                case 9:
                    _e.sent();
                    canvas.renderAll();
                    setPathImage(canvas.getElement().toDataURL());
                    originalCanvas = canvas.getElement();
                    canvasCopy = document.createElement('canvas');
                    canvasCopy.width = originalCanvas.width;
                    canvasCopy.height = originalCanvas.height;
                    ctx = canvasCopy.getContext('2d');
                    if (ctx) {
                        ctx.save();
                        ctx.resetTransform();
                        ctx.setTransform(-Math.cos(Math.PI), -Math.sin(Math.PI), Math.sin(Math.PI), Math.cos(Math.PI), 0, canvasCopy.height);
                        ctx.globalCompositeOperation = 'copy';
                        ctx.drawImage(originalCanvas, 0, 0);
                        ctx.restore();
                    }
                    setPreviewTexture(canvasCopy.toDataURL());
                    canvas.clear();
                    canvas.dispose();
                    element.width = element.height = 0;
                    return [2];
            }
        });
    }); };
    useEffect(function () {
        if (isPathImage)
            createPathImage();
    }, [selectedColor, avatarImages, isPathImage]);
    var generateBackSideNewImage = function (bodyImage) {
        var backSideNewImage = cloneDeep(bodyImage);
        var guideSvg = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"54\" height=\"65\" viewBox=\"0 0 54 65\" class=\"!_sz-h-full !_sz-w-full\" preserveAspectRatio=\"xMidYMax meet\" fill=\"#FF543E\" color=\"#FF543E\"><path d=\"M48.498 39.84C45.657 53.094 38.813 65 27 65S8.372 53.127 5.517 39.91C.562 39.343 0 33.389 0 29.65c0-3.154 1.93-4.669 4.553-5.461C4.9 10.997 7.5 0 27 0c18.252 0 21.795 9.998 22.39 24.172 2.653.772 4.61 2.302 4.61 5.477 0 3.523-1.125 7.983-5.502 10.192z\" fill-opacity=\"0.06\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M49.384 39.336c-.28.179-.575.348-.886.505-.07.325-.142.649-.217.972l-.974-.225c.073-.318.144-.637.213-.957l.1-.467.427-.216a8.96 8.96 0 00.797-.454l.54.842zm-1.58 3.41l-.967-.256a57.458 57.458 0 01-.532 1.883l.958.288c.19-.632.37-1.27.54-1.915zm-1.15 3.812l-.946-.323c-.212.62-.434 1.232-.667 1.834l.933.36c.238-.614.464-1.239.68-1.87zm-1.437 3.712l-.916-.4c-.263.6-.536 1.187-.821 1.761l.896.445c.292-.59.572-1.192.84-1.806zm-1.772 3.565l-.871-.492c-.32.568-.653 1.119-.998 1.651l.84.544c.356-.55.699-1.119 1.029-1.703zm-2.167 3.338l-.8-.6c-.389.519-.79 1.015-1.205 1.487l.752.66c.432-.493.85-1.01 1.253-1.547zm-2.63 2.985l-.69-.724a18.99 18.99 0 01-1.43 1.238l.616.788c.518-.404 1.02-.84 1.505-1.302zm-3.137 2.44l-.524-.852c-.534.329-1.083.624-1.647.885l.419.908a16.602 16.602 0 001.752-.942zm-3.607 1.66l-.302-.954c-.586.185-1.189.336-1.808.448l.179.984c.661-.12 1.305-.28 1.93-.479zm-3.908.713l-.058-.998a16.202 16.202 0 01-1.875 0l-.057.999a17.249 17.249 0 001.99 0zm-3.963-.233l.178-.984a14.731 14.731 0 01-1.805-.446l-.3.954c.624.197 1.266.356 1.927.476zm-3.78-1.191l.418-.909a15.568 15.568 0 01-1.645-.88l-.524.851c.566.348 1.15.661 1.75.938zm-3.381-2.07l.614-.79c-.49-.381-.966-.793-1.428-1.232l-.69.724c.485.461.986.894 1.504 1.298zm-2.879-2.732l.75-.66a24.559 24.559 0 01-1.202-1.483l-.8.6c.402.537.82 1.052 1.252 1.543zm-2.389-3.174l.839-.544a31.947 31.947 0 01-.997-1.647l-.87.492c.33.583.672 1.15 1.028 1.7zm-1.96-3.453l.896-.446a40.41 40.41 0 01-.82-1.757l-.916.401c.268.613.549 1.214.84 1.801zm-1.598-3.639l.933-.361c-.233-.6-.455-1.21-.667-1.83l-.946.325c.216.63.443 1.253.68 1.866zm-1.29-3.759l.958-.29a57.645 57.645 0 01-.533-1.878l-.967.257c.17.643.352 1.28.542 1.911zm-1.021-3.84l.974-.226a64.237 64.237 0 01-.214-.955l-.152-.7-.712-.082a4.735 4.735 0 01-.866-.179l-.296.955c.326.101.674.175 1.048.218.07.324.143.647.218.97zm-3.112-2.234l.67-.743c-.422-.38-.776-.857-1.07-1.418l-.886.465c.339.645.76 1.223 1.286 1.696zM.577 34.954l.966-.26c-.17-.632-.29-1.296-.373-1.965l-.992.123c.087.705.215 1.416.4 2.102zm-.56-4.235l1-.033A31.587 31.587 0 011 29.649c0-.296.02-.57.056-.822l-.99-.142A6.809 6.809 0 000 29.65c0 .34.005.699.017 1.07zm.66-3.853l.865.5a3.819 3.819 0 011.018-1.133l-.605-.797a4.82 4.82 0 00-1.279 1.43zm2.964-2.36l.373.928a9.99 9.99 0 01.828-.288l.692-.21.019-.721c.008-.318.018-.635.03-.95l-1-.035c-.012.318-.021.638-.03.959-.314.095-.619.2-.912.317zm1.031-3.19l.998.059c.038-.635.084-1.261.14-1.878l-.997-.09a61.863 61.863 0 00-.14 1.909zm.35-3.815l.992.13a37.1 37.1 0 01.286-1.843l-.984-.18c-.113.62-.21 1.252-.294 1.893zm.693-3.764l.971.24c.15-.606.319-1.195.508-1.767l-.949-.314a24.798 24.798 0 00-.53 1.841zm1.215-3.63l.915.402c.245-.559.515-1.096.813-1.611l-.866-.5c-.317.549-.604 1.12-.862 1.709zm1.917-3.305l.798.603c.357-.472.744-.921 1.165-1.347l-.71-.703c-.454.458-.87.94-1.253 1.447zm2.686-2.716l.612.791c.46-.355.953-.69 1.482-1.002l-.508-.862c-.565.334-1.092.692-1.586 1.073zm3.285-1.948l.408.913a18.71 18.71 0 011.697-.66l-.318-.948c-.628.21-1.223.442-1.787.695zM18.44.912l.239.971c.577-.142 1.18-.268 1.812-.377L20.32.52c-.654.113-1.28.243-1.881.391zm3.774-.66l.112.993a37.212 37.212 0 011.854-.16l-.062-.999c-.656.041-1.291.097-1.904.166zM26.03.009l.02 1a49.011 49.011 0 011.892 0l.02-1a48.134 48.134 0 00-1.932 0zm3.83.08l-.065.997c.634.041 1.246.096 1.836.165l.116-.993a36.575 36.575 0 00-1.888-.17zm3.776.447l-.177.984c.622.112 1.217.24 1.786.386l.248-.969a26.196 26.196 0 00-1.857-.401zm3.678.949l-.33.944c.587.205 1.142.43 1.668.675l.422-.907a18.99 18.99 0 00-1.76-.712zm3.438 1.612l-.524.852c.517.317 1 .658 1.453 1.02l.625-.78a15.146 15.146 0 00-1.554-1.092zm2.956 2.375l-.722.692c.41.427.79.88 1.142 1.356l.804-.595a14.86 14.86 0 00-1.224-1.453zm2.261 3.047l-.868.496c.292.513.56 1.048.807 1.607l.915-.404a18.423 18.423 0 00-.854-1.699zm1.542 3.47l-.946.323c.192.565.366 1.149.524 1.752l.967-.253a26.181 26.181 0 00-.545-1.822zm3.456 26.07l-.71-.704c.437-.44.81-.918 1.128-1.422l.847.533a9.278 9.278 0 01-1.265 1.594zm2.171-3.416c.247-.643.432-1.3.566-1.956l-.98-.2a11.383 11.383 0 01-.52 1.798l.934.358zm.83-3.975l-.998-.063c.02-.324.03-.644.03-.956 0-.298-.02-.574-.056-.829l.99-.142c.043.305.066.629.066.971 0 .332-.01.673-.032 1.019zm-.654-3.823l-.864.503a3.834 3.834 0 00-1.032-1.139l.6-.8c.525.395.965.867 1.296 1.436zm-4.09-5.523l-.998.077a59.996 59.996 0 00-.173-1.864l.994-.108c.068.62.126 1.253.176 1.895zm-.42-3.782l-.988.148a38.457 38.457 0 00-.316-1.826l.981-.195c.121.61.229 1.235.324 1.873zm.542 5.68l-.999.052c.017.312.031.626.045.942l.03.718.69.2c.292.085.571.18.836.283l.365-.931c-.296-.116-.604-.22-.922-.312-.014-.32-.029-.637-.045-.953z\"></path><path d=\"M27.833 26.5v6.667H34.5v1.666h-6.667V41.5h-1.666v-6.667H19.5v-1.666h6.667V26.5h1.666z\"></path></svg>";
        fabric.loadSVGFromString(guideSvg, function (objects, options) {
            var svgObject = fabric.util.groupSVGElements(objects, options);
            svgObject
                .set({
                left: (((backSideNewImage.height * 2) / option.origin.height) *
                    option.origin.face[0].left) /
                    2,
                top: (((backSideNewImage.width * 2) / option.origin.width) *
                    option.origin.face[0].top) /
                    2
            })
                .scale(1.1);
            backSideNewImage.add(svgObject);
        });
        backSideNewImage.renderAll();
        setBackSideNewImage(backSideNewImage.getElement().toDataURL());
    };
    return (_jsx(_Fragment, { children: pathImage ? (typeof pathImage === 'string' && (_jsx("img", { className: classNames('_sz-absolute _sz-bottom-0 _sz-max-w-full', {
                '_sz-bottom-6 _sz-pt-0 _sz-pr-6 _sz-pl-6 _sz-pb-6': option.origin.type === 'balloon'
            }), src: pathImage, "data-texture": previewTexture, onLoad: function () { return handleLoaded(); } }))) : (_jsxs("div", { className: "_sz-relative _sz-flex _sz-h-full _sz-w-full _sz-justify-center _sz-overflow-hidden", children: [_jsx("img", { className: "_sz-absolute _sz-bottom-0 _sz-h-full _sz-max-w-full", style: { zIndex: getZIndex('body', option.origin) }, src: thumbnailOss(bodyUrl, 300), onLoad: function () { return handleLoaded('body'); } }), (avatars.length > 0
                    ? avatars
                    : new Array(peopleNumber).fill(undefined)).map(function (avatar, index) {
                    var _a;
                    var left = Array.isArray(avatarLeft)
                        ? avatarLeft[index]
                        : avatarLeft;
                    var top = Array.isArray(avatarTop) ? avatarTop[index] : avatarTop;
                    var width = Array.isArray(avatarWidth)
                        ? avatarWidth[index]
                        : avatarWidth;
                    var height = Array.isArray(avatarHeight)
                        ? avatarHeight[index]
                        : avatarHeight;
                    var aScale = Array.isArray(avatarScale)
                        ? avatarScale[index]
                        : avatarScale;
                    var angle = 0;
                    if (avatarAngle && !Array.isArray(avatarAngle))
                        angle = avatarAngle;
                    else if (avatarAngle && Array.isArray(avatarAngle)) {
                        var angleItem = avatarAngle[index];
                        if (angleItem)
                            angle = angleItem;
                    }
                    return (_jsxs(Fragment, { children: [_jsx("div", { className: "_sz-absolute _sz-bg-contain _sz-bg-bottom _sz-bg-no-repeat", style: {
                                    left: left,
                                    top: top,
                                    width: width,
                                    height: height,
                                    backgroundImage: !(avatar === null || avatar === void 0 ? void 0 : avatar.isDefault)
                                        ? "url(".concat(avatar === null || avatar === void 0 ? void 0 : avatar.image, ")")
                                        : undefined,
                                    transform: "translate(-50%, -100%) ".concat(angle !== 0 ? "rotate(".concat(angle, "deg)") : ''),
                                    zIndex: option.origin.face[index].zIndex === undefined
                                        ? getZIndex('face', option.origin, index)
                                        : option.origin.face[index].zIndex
                                }, children: (avatar === null || avatar === void 0 ? void 0 : avatar.isDefault) && (_jsx(DefaultFace, { className: "!_sz-h-full !_sz-w-full", preserveAspectRatio: "xMidYMax meet", fill: "var(--sunzi-theme-color)", color: "var(--sunzi-theme-color)" })) }), (_a = option.origin.annex) === null || _a === void 0 ? void 0 : _a.map(function (annexData) {
                                if ((annexData.belongIndex === undefined && index !== 0) ||
                                    (annexData.belongIndex !== undefined &&
                                        annexData.belongIndex !== index)) {
                                    return null;
                                }
                                var result = annexData.images.find(function (item) {
                                    return item.color.includes(selectedColor.map(function (item) { return item.name; }).join('-'));
                                });
                                var imageUrl = (result === null || result === void 0 ? void 0 : result.url) || '';
                                var url = thumbnailOss(imageUrl, 200);
                                var scale = 200 / annexData.width;
                                if (annexData.height > annexData.width) {
                                    scale = 200 / annexData.height;
                                }
                                var annexDataWidth = annexData.width * scale;
                                var annexDataHeight = annexData.height * scale;
                                if ((avatar === null || avatar === void 0 ? void 0 : avatar.faceRecognizeData) &&
                                    avatarScale &&
                                    option.origin.face) {
                                    var face = option.origin.face;
                                    var faceItem = face[annexData.belongIndex || 0];
                                    var faceRect = avatar.faceRecognizeData.faceRect;
                                    var _a = annexData.faceFit, leftPoint = _a.leftPoint, rightPoint = _a.rightPoint, feature = _a.feature;
                                    var avatarFaceWidth = faceRect.width * aScale;
                                    var faceFitWidth = (faceItem.width / option.origin.width) * bottomImageWidth;
                                    var faceFitLeft = (faceItem.left / option.origin.width) * bottomImageWidth;
                                    var keyPoint = getKeyPoint(avatar, feature);
                                    var annexTop = void 0;
                                    var annexScale = avatarFaceWidth /
                                        ((rightPoint.left - leftPoint.left) * scale);
                                    var tempAvatarHeight = typeof height === 'string'
                                        ? (parseFloat(height) / 100) * bottomImageHeight
                                        : height;
                                    var tempAvatarTop = typeof top === 'string'
                                        ? (parseFloat(top) / 100) * bottomImageHeight
                                        : top;
                                    if (feature === 'head') {
                                        annexTop =
                                            tempAvatarTop -
                                                tempAvatarHeight +
                                                keyPoint.y * aScale -
                                                100 * aScale -
                                                leftPoint.top * scale * annexScale;
                                    }
                                    else {
                                        annexTop =
                                            tempAvatarTop -
                                                tempAvatarHeight +
                                                keyPoint.y * aScale -
                                                leftPoint.top * scale * annexScale;
                                    }
                                    var faceLeft = faceFitLeft + (faceFitWidth - avatarFaceWidth) / 2;
                                    var annexLeft = faceLeft - leftPoint.left * scale * annexScale;
                                    return (_jsx("img", { className: "_sz-absolute _sz-object-contain", src: url, onLoad: function () { return handleLoaded("annex-".concat(annexData.id)); }, style: {
                                            left: annexLeft,
                                            top: annexTop,
                                            width: annexDataWidth * annexScale,
                                            height: annexDataHeight * annexScale,
                                            zIndex: option.origin.face.length + 1
                                        } }, annexData.id));
                                }
                                else {
                                    var left_1 = (annexData.left / option.origin.width) * bottomImageWidth;
                                    var top_1 = (annexData.top / option.origin.height) *
                                        ((option.origin.height / option.origin.width) *
                                            bottomImageWidth);
                                    return (_jsx("img", { className: "_sz-absolute _sz-object-contain", src: thumbnailOss(annexData.images[0].url, Math.round((bottomImageWidth / option.origin.width) *
                                            annexData.width)), onLoad: function () {
                                            delete option.loading["annex-".concat(annexData.id)];
                                            forceUpdate();
                                        }, style: {
                                            left: left_1,
                                            top: top_1,
                                            zIndex: option.origin.face.length + 1
                                        } }, annexData.id));
                                }
                            })] }, index));
                })] })) }));
};
export default ChoosePreviewOption;
